import * as Immutable from "immutable";
import orderCaptureService from "../../../services/order-capture-service";
import moment from "moment-timezone";
import _ from "lodash";

let LOAD_ORDER_CAPTURE_DYNAMIC_FORM_FOR_CARD =
  "LOAD_ORDER_CAPTURE_DYNAMIC_FORM_FOR_CARD";
let LOAD_ORDER_CAPTURE_DATA = "LOAD_ORDER_CAPTURE_DATA";
let SET_ORDER_CAPTURE_FILTER = "SET_ORDER_CAPTURE_FILTER";
let UPDATE_ORDER_CAPTURE_DATA = "UPDATE_ORDER_CAPTURE_DATA";
let LOAD_USER_DETAILS = "LOAD_USER_DETAILS";

export function loadOrderCaptureFormForCard() {
  return (dispatch, getState) => {
    return orderCaptureService
      .getOrderCaptureForm()
      .then(function (orderCaptureForm) {
        dispatch({
          type: LOAD_ORDER_CAPTURE_DYNAMIC_FORM_FOR_CARD,
          orderCaptureForm: orderCaptureForm,
        });
      });
  };
}

export function loadOrderCaptureData(filter) {
  return (dispatch, getState) => {
    return orderCaptureService
      .getOrderCaptureByDateRange(filter)
      .then(function (orderCaptureData) {
        dispatch({
          type: LOAD_ORDER_CAPTURE_DATA,
          orderCaptureData: Immutable.fromJS(orderCaptureData),
        });
      });
  };
}

export function setOrderCaptureFilter(filter) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_ORDER_CAPTURE_FILTER,
      filter: filter,
    });
  };
}

export function updateOrderCapture(
  filter,
  newOrderCaptureUpdate,
  orderCaptureKey
) {
  return (dispatch, getState) => {
    return orderCaptureService
      .getOrderCaptureByDateRange(filter)
      .then(function (orderCaptureData) {
        let newCardId = orderCaptureKey.split("_");
        _.extend(
          _.find(orderCaptureData, {
            id: newCardId[0],
            orderCapture: { createdDate: newCardId[1] },
          }).orderCapture,
          newOrderCaptureUpdate
        );
        dispatch({
          type: UPDATE_ORDER_CAPTURE_DATA,
          orderCaptureData: Immutable.fromJS(orderCaptureData),
        });
      });
  };
}

export function loadUserDetails() {
  return (dispatch, getState) => {
    // return orderCaptureService.getUserDetails()
    //   .then(function (userDetails) {
    //     dispatch({
    //       type: LOAD_USER_DETAILS,
    //       userDetails: userDetails
    //     })
    //   })
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

let defaultOrderCaptureForm = {};

export function orderCaptureFormForCardReducer(
  state = defaultOrderCaptureForm,
  action
) {
  switch (action.type) {
    case LOAD_ORDER_CAPTURE_DYNAMIC_FORM_FOR_CARD: {
      return action.orderCaptureForm;
    }
    default:
      return state;
  }
}

let defaultFilter = Immutable.fromJS({
  startDate: moment().subtract(6, "days").toDate(),
  endDate: moment().toDate(),
  storeNames: [],
});

export function orderCaptureFilterReducer(state = defaultFilter, action) {
  switch (action.type) {
    case SET_ORDER_CAPTURE_FILTER: {
      return action.filter;
    }
    default:
      return state;
  }
}

let defaultOrderCaptureData = Immutable.fromJS([]);

export function orderCapturesDataReducer(
  state = defaultOrderCaptureData,
  action
) {
  switch (action.type) {
    case LOAD_ORDER_CAPTURE_DATA: {
      return action.orderCaptureData;
    }
    case UPDATE_ORDER_CAPTURE_DATA: {
      return action.orderCaptureData;
    }
    default:
      return state;
  }
}

export function userDetailsReducer(state = "", action) {
  switch (action.type) {
    case LOAD_USER_DETAILS: {
      return action.userDetails;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/OrderCapture/models/orderCaptures.js